// Mobi2Go.UI
// Namespace for anything UI related, contains a view constructor, a place
// to store all view instances and event methods to view-to-view
// communication
import jQuery from 'jquery';
import _ from 'lodash';

Mobi2Go.UI = Mobi2Go.UI || {};

// Add event methods to UI
Mobi2Go.app.mixinEvents('UI', Mobi2Go.UI);

// Views object collection
Mobi2Go.UI.views = {};

// Add Platform data attribute (i don't know where this should go!)
jQuery('#m2g-view').attr('data-platform', Mobi2Go.app.getPlatform());

// View object contructor - Backbone-esque
Mobi2Go.UI.View = function(options) {
    if (!(this instanceof Mobi2Go.UI.View)) {
        return new Mobi2Go.UI.View(options);
    }

    const options_keys = [
        'name',
        'model',
        'el',
        'model_listeners',
        'DOM_listeners',
        'triggers',
        'initialise',
        'template',
        'templates',
    ];
    const templates = {};
    let key;

    this.model = Mobi2Go[options.model] || options.model;
    this.name = options.name || `view#${_.uniqueId()}`;

    this.el = options.el || null; // Container element of this view
    this.$el = options.el ? jQuery(options.el) : null; // jQuery selector

    // Underscore template html of this view
    this.template = options.template ? _.template(options.template) : null;
    this.templates = {};
    // Multiple templates
    if (_.isObject(options.templates)) {
        _.each(options.templates, function(template_html, template_name) {
            templates[template_name] = _.template(template_html);
        });
        this.templates = templates;
    }

    // Extend this instance with any functions in the options object that
    // aren't key words
    for (key in options)
        if (options.hasOwnProperty(key)) {
            if (!_.includes(options_keys, key)) {
                // If property is a function - bind its context to this
                if (_.isFunction(options[key])) {
                    options[key] = _.bind(options[key], this);
                }
                this[key] = options[key];
            }
        }

    // Object of model events associated with either names of methods of
    // this view or anon functions
    // which will be bound to the model
    this.model_listeners = options.model_listeners || {};
    this.bindModelListeners();

    // Object of DOM events associated with either naes of methods of this
    // view or anon functions which will be bound to this View. DOM events
    this.DOM_listeners = options.DOM_listeners || {};
    this.bindDOMListeners();

    Mobi2Go.app.mixinEvents(`View.${this.name}`, this);

    if (_.isFunction(options.initialise)) {
        options.initialise.call(this);
    }

    Mobi2Go.UI.views[this.name] = this;
};

_.extend(Mobi2Go.UI.View.prototype, {
    initialise() {},
    // Restrain jQuery selectors to view's el
    jQuery(selector) {
        return this?.$el?.find(selector);
    },
    setModel(model) {
        // If a model was previously bound to this view
        // unbind any listeners on that model before assigning a new model
        if (this.model) {
            this.unbindModelListeners();
        }
        this.model = model;
        this.bindModelListeners(); // Assign listeners to this model
    },
    setEl(el) {
        if (this.el) {
            this.unbindDOMListeners();
        }

        this.el = el;
        this.$el = jQuery(el);
        this.bindDOMListeners();
    },
    bindModelListeners() {
        let i;
        let method;
        const listeners = this.model_listeners;
        if (!listeners || !_.isObject(listeners) || !this.model) {
            return;
        }

        if (!this.model_listeners_parsed) {
            for (i in listeners)
                if (listeners.hasOwnProperty(i)) {
                    method = listeners[i];
                    if (!_.isFunction(method) && _.isFunction(this[method])) {
                        method = this[method];
                    }
                    if (!_.isFunction(method)) {
                        throw `"${String(method)}" is not a function`;
                        delete listeners[i];
                    }

                    method = _.bind(method, this);
                    listeners[i] = method;
                }
            this.model_listeners = listeners;
            this.model_listeners_parsed = true;
        }

        this.model.bind(this.model_listeners);
    },
    unbindModelListeners() {
        if (this.model) this.model.unbind(this.model_listeners);
    },
    bound_DOM_Listeners: {},
    bindDOMListeners() {
        let key;
        let split;
        let event_name;
        let selector;
        let method;
        const triggers = this.DOM_listeners;
        if (!triggers || !_.isObject(triggers) || !this.el) {
            return;
        }

        for (key in triggers)
            if (triggers.hasOwnProperty(key)) {
                split = key.match(/^(\S+)\s*(.*)$/);
                event_name = split[1];
                selector = split[2];
                method = triggers[key];

                if (!_.isFunction(method)) {
                    if (_.isFunction(this[method])) {
                        method = this[method];
                    } else {
                        throw new Error(
                            `"${String(method)}" is not a function`
                        );
                    }
                }
                method = _.bind(method, this); // Bind method to this context

                this.bound_DOM_Listeners[key] = method;

                if (selector === '') {
                    this.$el.bind(event_name, method);
                } else {
                    this.$el.delegate(selector, event_name, method);
                }
            }
    },
    unbindDOMListeners() {
        let key;
        let split;
        let event_name;
        let selector;
        let method;
        const triggers = this.DOM_listeners;
        if (!triggers || !_.isObject(triggers) || !this.el) {
            return;
        }

        for (key in triggers)
            if (triggers.hasOwnProperty(key)) {
                split = key.match(/^(\S+)\s*(.*)$/);
                event_name = split[1];
                selector = split[2];
                method = triggers[key];

                if (!_.isFunction(method)) {
                    if (_.isFunction(this[method])) {
                        method = this[method];
                    } else {
                        throw new Error(
                            `"${String(method)}" is not a function`
                        );
                    }
                }
                method = this.bound_DOM_Listeners[key];

                if (selector === '') {
                    this.$el.unbind(event_name, method);
                } else {
                    this.$el.undelegate(selector, event_name, method);
                }
            }

        this.bound_DOM_Listeners = {};
    },
});

/**-------------------------------------------------------------------------
 * Scroll Offset
 * Some embeded pages have fixed nav menus, which breaks some scrolling
 * funcionality. e.g. Elements that are scrolled into position are
 */
Mobi2Go.UI.global_page_scroll_offset = 0;
